import React, { useRef, useEffect, useState, useCallback, Suspense } from "react";
import styles from "./index.module.less";
// import * as echarts from "echarts/core";
// import { LineChart } from "echarts/charts";
// import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
// import { CanvasRenderer } from "echarts/renderers";
// import {
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   TransformComponent
// } from "echarts/components";
// import mocks from "./mock";
import AppItem from "../RightContent/AppItem";
import ScrollView from "@/baseComponents/ScrollView";
import IconFont from "@/components/icon";
import { RightOutlined } from "@/utils/antdIcon";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { notifyer } from "@/components/ThirdApp";
import dayjs from "dayjs";
import { FocusSDK, isFocusEnv } from "@/utils";
import Bus from "@/utils/bus";
import { clone } from "lodash";
// import Charts from "@/baseComponents/Charts";
const Charts = React.lazy(() => import("@/baseComponents/Charts"));

const ChartsParentComponent = React.memo(({ children }) => {
  return (
    <Suspense fallback={<div>加载中...</div>}>
      {children}
    </Suspense>
  );
});

// echarts.use([
//   LineChart,
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   TransformComponent,
//   LabelLayout,
//   UniversalTransition,
//   CanvasRenderer
// ]);
export const ANALYSIS_APPKEY_PRE = "xnCBG0U3p13K5EV3IzVo";
export const ANALYSIS_APPKEY_PROD = "EDlVEqwKivQq2rTwE5BQ";
export default function NewThirdappAnalysis() {
  const { service, appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  // let myChart: any = null;
  const myRef = useRef<HTMLDivElement | null>(null);
  const scrollRef = useRef();
  const [appData, setAppData] = useState<any>({ applicationList: [] });
  const [monthAppData, setMonthAppData] = useState<any>();
  const [chartOptions, setChartOptions] = useState<any>({
    tooltip: {},
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: [],
      axisLabel: {
        show: true,
        formatter: (val: string, index: number) => {
          if (index === 0) {
            return "";
          } else {
            return val;
          }
        }
      }
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data: [],
        type: "line",
        itemStyle: { normal: { label: { show: true } } }
      }
    ]
  });

  // useEffect(() => {
  //   if (myRef?.current) {
  //     myChart = echarts.init(myRef?.current);
  //   }
  // }, [myRef]);

  // useEffect(() => {
  //   window.onresize = function () {
  //     myChart.resize();
  //   };
  // }, []);

  useEffect(() => {
    service.appStoreService
      .getApplicationCountAndList({})
      .then((res: any) => {
        setAppData(res);
      })
      .catch((e) => { });
    service.appStoreService
      .getMonthApplicationCountList({})
      .then((res) => {
        setMonthAppData(res);
        const chartOpt = clone(chartOptions);
        res?.timeCount?.forEach((item: any) => {
          chartOpt.xAxis.data.push(`${dayjs(item.month).format("MM")}月`);
          chartOpt.series[0].data.push(item.count);
        });
        setChartOptions(chartOpt);
        // myChart?.setOption(chartOptions);
      })
      .catch((e) => { });
  }, []);

  const onOpenLink = useCallback(async () => {
    let appkey = "";
    if (isFocusEnv()) {
      if (appRuntimeEnv.env === "prod") {
        appkey = ANALYSIS_APPKEY_PROD;
      } else {
        appkey = ANALYSIS_APPKEY_PRE;
      }
    } else {
      appkey = process.env.REACT_APP_ANALYSIS_APPKEY || "";
    }
    try {
      const appInfo: any = await service.appStoreService.getApplication({ applicationKey: appkey });
      Bus.emit("openThirdApp", appInfo.application);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <div className={styles["container"]}>
      <div className={styles["header"]}>
        <span className={styles["header_icon"]}>
          <IconFont type="iconic_pc_statistics" />
        </span>
        新增应用统计
      </div>
      <div className={styles["content"]}>
        <ScrollView ref={scrollRef} autoHide id="content_scroll_id">
          <div
            className={`third-right-content ${styles["item_container"]} ${styles["thirdapp_container"]}`}
          >
            <div className={styles["title"]}>
              <div className={styles["content"]}>
                <span className={styles["icon"]}>
                  <IconFont type="iconic_pc_newadded" />
                </span>
                新增应用
                <span className={styles["num"]}>{appData.monthCount}</span>
                <span className={styles["desc"]}>（近3个月）</span>
              </div>
            </div>
            <div className={styles["thirdapp_container_content"]}>
              {appData?.applicationList?.map((item: any, index: number) => {
                return (
                  <AppItem
                    key={index}
                    appInfo={item}
                    moreHidden={true}
                    eventHidden={true}
                    tooltipHidden={true}
                  />
                );
              })}
            </div>
          </div>
          <div className={`${styles["item_container"]} ${styles["analysis_container"]}`}>
            <div className={styles["title"]}>
              <div className={styles["content"]}>
                <span className={styles["icon"]}>
                  <IconFont type="iconic_pc_total" />
                </span>
                应用总数
                <span className={styles["num"]}>{monthAppData?.total}</span>
              </div>
              <div className={styles["more"]} onClick={onOpenLink}>
                {(window as any)?._BTS_CONFIG?.REACT_APP_NAME || process.env.REACT_APP_NAME || '京办'}数据统计
                <RightOutlined className={styles["more-icon"]} />
              </div>
            </div>
            <div ref={myRef} style={{ width: "100%", height: "457px" }}>
              <ChartsParentComponent>
                <Charts option={chartOptions} chartDom={myRef?.current} />
              </ChartsParentComponent>
            </div>
          </div>
        </ScrollView>
      </div>
    </div>
  );
}
